import { apiUrl, httpClient } from "@/utilities";
import {
  DataProvider,
  GetListParams,
  GetListResult,
  RaRecord,
} from "react-admin";

const gameoo_resource = "users";

const cashierProvider: Partial<DataProvider> = {
  getList: async <RecordType extends RaRecord>(
    resource: string,
    params?: GetListParams
  ): Promise<GetListResult<RecordType>> => {
    resource = gameoo_resource;
    const { page = 1, perPage = 10 } = params?.pagination ?? {};
    const { field = "", order = "" } = params?.sort ?? {};

    const query = params
      ? {
          filter: JSON.stringify(params.filter),
          range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
          sort: JSON.stringify([field, order]),
        }
      : "";

    const url = `${apiUrl}/${resource}?${new URLSearchParams(query)}`;
    const response = await httpClient(url);

    // Ensure response has `json` and headers
    if (!response.json || !Array.isArray(response.json.data)) {
      throw new Error(
        "Invalid API response: Expected { data: [...], total: number }"
      );
    }

    return {
      data: response.json.data,
      total: response.json.total ?? response.json.data.length,
    };
  },

  getOne: async (resource, params) => {
    resource = gameoo_resource;
    if (resource !== gameoo_resource) return Promise.reject();

    const queryParams = new URLSearchParams({
      id: String(params.id),
    }).toString();
    const url = `${apiUrl}/${gameoo_resource}/info?${queryParams}`;
    const response = await httpClient(url, { method: "GET" });

    return { data: response.json };
  },

  create: async (resource, params) => {
    resource = gameoo_resource;
    if (resource !== gameoo_resource) return Promise.reject();

    const url = `${apiUrl}/${gameoo_resource}`;
    const response = await httpClient(url, {
      method: "POST",
      body: JSON.stringify(params.data),
    });

    return { data: response.json };
  },

  update: async (resource, params) => {
    resource = gameoo_resource;
    if (resource !== gameoo_resource) return Promise.reject();

    const url = `${apiUrl}/${gameoo_resource}/${params.id}`;
    const response = await httpClient(url, {
      method: "PATCH",
      body: JSON.stringify(params.data),
    });

    return { data: response.json };
  },

  getMany: async (resource, params) => {
    resource = gameoo_resource;
    const queryParams = new URLSearchParams({ ids: params.ids.join(",") });
    const url = `${apiUrl}/${resource}/many?${queryParams.toString()}`;
    const { json } = await httpClient(url);
    return { data: json };
  },
};

export default cashierProvider;
